<template>
    <v-container style="margin-right: 0px;margin-left: 0px; margin-top: 20px; width: 100%;">
        <v-layout row wrap>
            <v-flex xs12 md6>
                <v-select name="yearCommercial" v-bind:label="$t('message.yearCommercial')" v-validate="'required'"
                    :error-messages="errors.collect('yearCommercial')" item-text="Valor" :items="yearCommercialList"
                    v-model="yearComercial" @change="getBusinessLine()"></v-select>
            </v-flex>
            <v-flex xs12 md6>
                <v-select name="lineBusiness" v-bind:label="$t('message.lineBusiness')" v-validate="'required'"
                    :error-messages="errors.collect('lineBusiness')" :items="catalogTypeOfLineBusiness" item-text="value"
                    v-model="lineBusiness"></v-select>
            </v-flex>

            <v-flex xs12 md6>
                <v-select name="startWeek" v-bind:label="$t('message.startWeek')" v-validate="'required'"
                    :error-messages="errors.collect('startWeek')" item-text="Valor" :items="startWeekList"
                    v-model="startWeek"></v-select>
            </v-flex>

            <v-flex xs12 md6>
                <v-select name="endWeek" v-bind:label="$t('message.endWeek')" v-validate="'required'"
                    :error-messages="errors.collect('endWeek')" item-text="Valor" :items="endWeekList"
                    v-model="endWeek"></v-select>
            </v-flex>



        </v-layout>
        <v-layout row wrap justify-end>
            <v-btn style="height:50%" class="hidden-xs-only" small color="accent"
                @click="CargaInformacion()">Visualizar</v-btn>
        </v-layout>
        <v-layout>
            <h4 class="colorText" v-if="this.esVip">Considerar que NO bonifica N1 ya que cuenta con el beneficio del 2%
                adicional en su comisión. Si tiene alguna duda, por favor comuníquese con su ejecutivo comercial.</h4>
        </v-layout>
        <v-layout row wrap justify-center v-if="lineBusiness == 'INDIVIDUALES' && yearComercial < 2023 || lineBusiness == 'TODOS' && yearComercial < 2023">
            <Individuales ref="individuales" :tableIndividuales="tableIndividuales">
            </Individuales>

        </v-layout>
        <v-layout row wrap justify-center v-if="lineBusiness == 'CORPORATIVO' || lineBusiness == 'TODOS'">
            <Corporativos ref="corporativo" :dataCorporativo="dataCorporativo"></Corporativos>


        </v-layout>
        <v-layout row wrap justify-center v-if="lineBusiness == 'FIANZAS' || lineBusiness == 'TODOS'">
            <Fianzas ref="fianzas" :dataFianzas="dataFianzas"></Fianzas>

        </v-layout>
        <v-layout row wrap justify-center v-if="lineBusiness == 'PERSONAS' || lineBusiness == 'TODOS' && yearComercial > 2022">
            <personas ref="personas" :dataPersonas="dataPersonas"></personas>
            

        </v-layout>
        <v-layout row wrap justify-center v-if="lineBusiness == 'CUENTAS PUBLICAS' || lineBusiness == 'TODOS' && yearComercial > 2022 ">
            <CuentasPublicas ref="cuentasPublicas" :dataCuentasPublicas="dataCuentasPublicas"></CuentasPublicas>

        </v-layout>
        <v-layout row wrap justify-center v-if="lineBusiness == 'AUTOMOTRIZ' || lineBusiness == 'TODOS' && yearComercial > 2022">
            <Automotriz ref="automotriz" :dataAutomotriz="dataAutomotriz"></Automotriz>

        </v-layout>
        <v-layout row wrap justify-center v-if="lineBusiness == 'IFIS' || lineBusiness == 'TODOS' && yearComercial > 2022">
            <Ifis ref="ifis" :dataIfis="dataIfis"></Ifis>

        </v-layout>

        <h5 style=" margin-top:100px">Nota :El presupuesto que se refleja no toma en cuenta negocios
            facultativos

        </h5>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import CatalogServices from "@/services/CatalogsServices";
import Individuales from "./Individuales.vue";
import Fianzas from "./Fianzas.vue";
import Corporativos from "./Corporativos.vue";
import Personas from "./Personas.vue";
import Automotriz from "./Automotriz.vue";
import CuentasPublicas from "./CuentasPublicas.vue";
import Ifis from "./Ifis.vue";
import CommercialGraphicsServices from "@/services/CommercialGraphicsServices";

export default {
    components: {
        Individuales,
        Fianzas,
        Corporativos,
        Personas,
        Automotriz,
        CuentasPublicas,
        Ifis
    },

    mounted() {

    },
    computed: {
        ...mapGetters(["agency", "userProfile", "agencyName"]),
    },
    methods: {
        getBusinessLine() {

            if (this.yearComercial < 2023) 
            {
                CatalogServices.getTypeLineBusiness()
                    .then((response) => {
                        if (response.data.error == 0) {

                            this.catalogTypeOfLineBusiness = response.data.data.filter(({ code }) => (code == "1" || code == "5" || code == "3"));
                            this.catalogTypeOfLineBusiness.unshift({ code: "0", value: "TODOS" });
                        } else {
                            this.catalogTypeOfLineBusiness = [];
                        }
                    })
                    .catch((res) => {
                        this.$root.$emit("showSnackBar", "Error desconocido", "error");
                    });

            } else {
                CatalogServices.getLineBusinessByYear()
                    .then((response) => {
                        if (response.data.error == 0) {

                            this.catalogTypeOfLineBusiness = response.data.data;
                            this.catalogTypeOfLineBusiness.unshift({ code: "0", value: "TODOS" });
                        } else {
                            this.catalogTypeOfLineBusiness = [];
                        }
                    })
                    .catch((res) => {
                        this.$root.$emit("showSnackBar", "Error desconocido", "error");
                    });

                
            }

        },
        async getApsInfo(apsId) {

            let idAps = "";
            await CatalogServices.getDataApsInfo()

                .then((response) => {
                    idAps = response.data.data.filter(({ codeSiaerp }) => (codeSiaerp == apsId))[0]["code"]


                }).catch(() => {
                    this.$root.$emit("hideLoading");
                    this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
                })
            if (idAps == "" || idAps == undefined || idAps == null) {
                this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
                this.$root.$emit("hideLoading");
            }

            return idAps;
        },
        async CargaInformacion() {
            this.$root.$emit(
                "showLoading",
                "Cargando Bonos Nuevo Riesgo"
            );
            var broker = await this.getApsInfo(this.userProfile.user_id);

            await CommercialGraphicsServices.getBonoNuevoRiesgo(
                broker,
                this.yearComercial,
                this.startWeek,
                this.endWeek,
                "0",
                this.agencyName,
                this.lineBusiness

            )
                .then((response) => {
                    console.log(response)
                    if (response.data.error == 0) {

                        if (this.yearComercial < 2023) {
                            if (this.lineBusiness == "INDIVIDUALES") {
                                this.tableIndividuales = response.data.data[0].bonosNuevoRiesgo;

                            } else if (this.lineBusiness == "CORPORATIVO") {
                                this.dataCorporativo = response.data.data[0].bonosNuevoRiesgo;
                            } else if (this.lineBusiness == "FIANZAS") {

                                this.dataFianzas = response.data.data[0].bonosNuevoRiesgo;
                                // this.$refs.fianzas.CargarInformacion();
                            }

                            else {
                                this.dataCorporativo = response.data.data[0].bonosNuevoRiesgo;
                                this.tableIndividuales = response.data.data[1].bonosNuevoRiesgo;
                                this.dataFianzas = response.data.data[2].bonosNuevoRiesgo;

                            }


                            if (response.data.data[0].bonosNuevoRiesgo[0].Vip == "SI") {
                                this.esVip = true;
                            }

                        } else {

                            if (this.lineBusiness == "CUENTAS PUBLICAS") {
                                this.dataCuentasPublicas = response.data.data[0].bonosNuevoRiesgo;

                            } else if (this.lineBusiness == "CORPORATIVO") {
                                this.dataCorporativo = response.data.data[0].bonosNuevoRiesgo;
                            } else if (this.lineBusiness == "FIANZAS") {

                                this.dataFianzas = response.data.data[0].bonosNuevoRiesgo;
                                // this.$refs.fianzas.CargarInformacion();
                            } else if (this.lineBusiness == "AUTOMOTRIZ") {

                                this.dataAutomotriz = response.data.data[0].bonosNuevoRiesgo;
                                // this.$refs.fianzas.CargarInformacion();
                            }
                            else if (this.lineBusiness == "IFIS") {

                                this.dataIfis = response.data.data[0].bonosNuevoRiesgo;
                                // this.$refs.fianzas.CargarInformacion();
                            }
                            else if (this.lineBusiness == "PERSONAS") {

                                this.dataPersonas = response.data.data[0].bonosNuevoRiesgo;
                                // this.$refs.fianzas.CargarInformacion();
                            }

                            else {
                                this.dataCorporativo = response.data.data[0].bonosNuevoRiesgo;
                                this.dataCuentasPublicas = response.data.data[1].bonosNuevoRiesgo;
                                this.dataFianzas = response.data.data[2].bonosNuevoRiesgo;
                                this.dataAutomotriz = response.data.data[3].bonosNuevoRiesgo;
                                this.dataPersonas = response.data.data[4].bonosNuevoRiesgo;
                                this.dataIfis = response.data.data[5].bonosNuevoRiesgo;

                            }


                            if (response.data.data[0].bonosNuevoRiesgo[0].Vip == "SI") {
                                this.esVip = true;
                            }



                        }

                    } else {
                        this.$root.$emit("hideLoading");
                        this.$root.$emit("showSnackBar", "No se obtuvo Información ", "error");
                        this.catalogTypeOfLineBusiness = [];
                    }
                })
                .catch((res) => {
                    this.$root.$emit("hideLoading");
                    this.$root.$emit("showSnackBar", "Error: " + res, "error");
                }).finally(() => {
                    this.$root.$emit("hideLoading");

                });
            this.$root.$emit("hideLoading");


        }
    },
    data() {
        return {
            catalogTypeOfLineBusiness: [],
            esVip: false,
            yearComercial: "",
            lineBusiness: "TODOS",
            startWeek: "",
            endWeek: "",
            yearCommercialList: [
                "2012",
                "2013",
                "2014",
                "2015",
                "2016",
                "2017",
                "2018",
                "2019",
                "2020",
                "2021",
                "2022",
                "2023",
                "2024",
                "2025",
                "2026",
                "2027",
                "2028",
                "2029",
                "2030",
                "2031",
                "2032",
                "2033",
                "2034",
                "2035",
                "2036",
                "2037",
                "2038",
                "2039",
                "2040",
                "2041",
                "2042",
                "2043",
                "2044",
                "2045",
                "2046",
                "2047",
                "2048",
                "2049",
                "2050",
            ],
            startWeekList: [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23",
                "24",
                "25",
                "26",
                "27",
                "28",
                "29",
                "30",
                "31",
                "32",
                "33",
                "34",
                "35",
                "36",
                "37",
                "38",
                "39",
                "40",
                "41",
                "42",
                "43",
                "44",
                "45",
                "46",
                "47",
                "48",
                "49",
                "51",
                "52",
            ],
            endWeekList: [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23",
                "24",
                "25",
                "26",
                "27",
                "28",
                "29",
                "30",
                "31",
                "32",
                "33",
                "34",
                "35",
                "36",
                "37",
                "38",
                "39",
                "40",
                "41",
                "42",
                "43",
                "44",
                "45",
                "46",
                "47",
                "48",
                "49",
                "51",
                "52",
            ],
            tableIndividuales: [],
            dataCorporativo: [],
            dataFianzas: [],
            dataCuentasPublicas: [],
            dataPersonas: [],
            dataIfis: [],
            dataAutomotriz: [],

            headersSectionDetailsLines: [
                {
                    align: "center",
                    sortable: false,
                    text: "Semana Comercial",
                    value: "semanaComercial",
                    width: "18%",
                    class: "table-header-bono",
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Ingreso Eficiente",
                    value: "ingresoEficiente",
                    width: "14%",
                    class: "table-header-bono",
                },
                {
                    align: "center",
                    sortable: false,
                    text: "% De Cumplimiento",
                    value: "porcentajeCumplimiento",
                    width: "14%",
                    class: "table-header-bono",
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Bonifica",
                    value: "Bonifica",
                    width: "14%",
                    class: "table-header-bono",
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Presupuesto N2",
                    value: "presupuestoN2",
                    width: "14%",
                    class: "table-header-bono",
                },
                {
                    align: "center",
                    sortable: false,
                    text: "% de Cumplimiento",
                    value: "porcentajeCumplimiento2",
                    width: "14%",
                    class: "table-header-bono",
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Bonifica",
                    value: "Bonifica2",
                    width: "14%",
                    class: "table-header-bono",
                },
            ],
            newCatalogLineBusiness: [{
                "code": "0",
                "value": "TODOS"
            },
            {
                "code": "1",
                "value": "PERSONAS"
            },
            {
                "code": "2",
                "value": "CORPORATIVOS"
            },
            {
                "code": "3",
                "value": "CUENTAS PUBLICAS"
            },
            {
                "code": "4",
                "value": "FIANZAS"
            },
            {
                "code": "5",
                "value": "IFIS"
            },
            {
                "code": "5",
                "value": "AUTOMOTRIZ"
            }
            ],

        };
    },
};
</script>
<style lang="scss" >
$header-table-Bonos: #000349;
$principal-items: #000349 !default;
$grayColor: #dddddd !default;
$colorBlueTd: #a4cde8;
$colorRedTd: #e5a2c3;
$coloryellowTd: #fffb89;
$whiteColor: white;
$colorGreenTd: #a4d1a0;
$colorMoradoTd: #e5a2c3;
$colorNaranjaTd: #e49c73;

.colorGreentd {
    background-color: $colorGreenTd;
}

.colorMoradotd {
    background-color: $colorMoradoTd;
}

.colorNaranjatd {
    background-color: $colorNaranjaTd;
}

.v-label.v-label--active.theme--light.white--text {
    color: $principal-items;
    caret-color: #fff !important;
}

.white--text {
    /* color: #fff !important; */
    color: $principal-items !important;
    caret-color: #fff !important;
}

table tr>td:first-child {
    border-left: 1px solid $grayColor;
    color: $principal-items;
    font-size: medium;
}

.table {
    border: 1px solid $grayColor;
    background-color: transparent !important;
}

.v-table tr:hover:not(.v-table__expanded__content) {
    background: transparent !important;
}

.table th+th {
    border-left: 1px solid $grayColor;
}

.table td+td {
    border-left: 1px solid $grayColor;
}

.table-header-bono {
    background-color: $header-table-Bonos;
}

.theme--light .v-table thead th {
    color: $whiteColor;
    font-size: 14px;
}

.colorbluetd {
    background-color: $colorBlueTd;
}

.colorText {
    color: $principal-items;
}

.colorRedtd {
    background-color: $colorRedTd;
}

.coloryellowtd {
    background-color: $coloryellowTd;
}

.colorwhitetd {
    background-color: white;
}

@media only screen and (min-width: 1264px) {
    .container {
        max-width: 100%;
    }
}
</style>
